(function() {
  'use strict';

  // Prevent link navigation when clicking size buttons
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-pi-quick-add] .pi-quick-add__trigger');
    var sizeBtn = e.target.closest('[data-pi-add-variant]');

    // Plus icon tap (mobile)
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var container = trigger.closest('[data-pi-quick-add]');
      container.classList.toggle('is-active');
      return;
    }

    // Size button click
    if (sizeBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (sizeBtn.disabled || sizeBtn.classList.contains('is-loading')) return;

      var variantId = sizeBtn.getAttribute('data-pi-add-variant');
      if (!variantId) return;

      sizeBtn.classList.add('is-loading');
      var originalText = sizeBtn.textContent;
      sizeBtn.textContent = '…';

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }]
        })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function() {
        sizeBtn.textContent = '✓';
        setTimeout(function() {
          sizeBtn.textContent = originalText;
          sizeBtn.classList.remove('is-loading');
        }, 1200);

        // Update cart count
        return fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        });
      })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        // Update cart count indicators
        var countEls = document.querySelectorAll('.js-cart-count');
        countEls.forEach(function(el) {
          el.classList.remove('hidden');
          var inner = el.querySelector('.quick-cart__indicator-inner');
          if (inner) inner.textContent = cart.item_count;
        });

        // Try to open cart drawer if theme supports it
        var cartToggle = document.querySelector('.js-cart-drawer-toggle');
        if (cartToggle) cartToggle.click();
      })
      .catch(function() {
        sizeBtn.textContent = '!';
        setTimeout(function() {
          sizeBtn.textContent = originalText;
          sizeBtn.classList.remove('is-loading');
        }, 1500);
      });

      return;
    }
  }, true);

  // Close mobile size picker when tapping outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-pi-quick-add]')) {
      document.querySelectorAll('.pi-quick-add.is-active').forEach(function(el) {
        el.classList.remove('is-active');
      });
    }
  });
})();